<template>
    <Dashboard
        :title="__('Users', null, $page.props.profile_locale)"
    >
        <Heading
            :label="__('Users', null, $page.props.profile_locale)"
        />
        <div class="overflow-auto w-full shadow-md rounded-md">
        <table class="w-full whitespace-nowrap">
            <thead>
                <tr class="text-xs font-semibold tracking-wide text-left text-gray-200 uppercase border-b bg-gray-900 border-red-700">
                    <th class="px-2 py-2">{{__('Name', null, $page.props.profile_locale)}}</th>
                    <th class="px-2 py-2">{{__('Email', null, $page.props.profile_locale)}}</th>
                    <th class="px-2 py-2">{{__('Address', null, $page.props.profile_locale)}}</th>
                    <th class="px-2 py-2">{{__('Country', null, $page.props.profile_locale)}}</th>
                    <th class="px-2 py-2">{{__('Join date', null, $page.props.profile_locale)}}</th>
                    <th class="px-2 py-2">{{__('Actions', null, $page.props.profile_locale)}}</th>
                </tr>
            </thead>
            <tbody class="border border-t-0 rounded-b-md text-left">
                <tr
                    class="hover:bg-gray-200 text-gray-700 even:bg-gray-100"
                    v-for="user in users" :key="user.id"
                >
                    <td class="px-2 py-2 text-sm font-bold">{{ getFullName(user) }}</td>
                    <td class="px-2 py-2 text-sm font-bold"><a class="text-gray-900 hover:text-red-700" :href="'mailto:' + user.email">{{user.email}}</a></td>
                    <td class="px-2 py-2 text-sm whitespace-pre-wrap">
                        <div class="max-w-xs" v-html="getFullAddress(user)"></div>
                    </td>
                    <td class="px-2 py-2 text-sm whitespace-pre-wrap">
                        <div class="flex items-center flex-col space-y-2" v-if="user.country">
                            <img class="mx-1 w-6 h-6 max-w-max" :src="getLangImage(user.country)">
                            <span>{{ __('countries.' + user.country, null, $page.props.profile_locale) }}</span>
                        </div>
                        <span v-else>-</span>
                    </td>
                    <td class="px-2 py-2 text-sm">{{ getDate(user.created_at) }}</td>
                    <td class="px-2 py-2 text-sm text-center">
                        <div class="flex">
                            <IconLink
                                icon="settings"
                                class="flex flex-col mx-auto px-1"
                                :href="route('admin.users.profile', user.id)"
                            >
                            <template #addon>
                                <span class="font-bold">{{ __('Settings', null, $page.props.profile_locale)}}</span>
                            </template>
                            </IconLink>
                            <!-- v-if="!user.coupon || (user.coupon && user.coupon.type != 'first_transaction')" -->
                            <IconLink
                                @click.prevent="openModal(user)"
                                icon="cash"
                                class="flex flex-col mx-auto px-1"
                            >
                            <template #addon>
                                <span class="font-bold">{{ user.coupon ? __('Change discount', null, $page.props.profile_locale) : __('Assign a discount', null, $page.props.profile_locale)}}</span>
                            </template>
                            </IconLink>
                        </div>
                        <div
                            v-if="user.coupon && user.coupon.type == 'first_transaction'"
                            class="font-bold text-red-700 mt-2"
                        >{{ __('New customer', null, $page.props.profile_locale) }} / {{getDiscount(user.coupon)}}</div>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>

        <CustomModal
            :title="__('Choose a coupon', null, $page.props.profile_locale)"
            v-if="showModal.show"
            :animate-close="showModal.close"
            @update="ev => { showModal.show = ev; showModal.close = ev; }"
        >
        <div>
            <template
                v-for="item in coupons"
                :key="item.id"
            >
                <div
                    class="cursor-pointer font-bold p-2 rounded-md mb-2 flex space-x-4"
                    v-if="item.type != 'first_transaction' || (item.type === 'first_transaction' && !form.user.firstTransaction)"

                    :class="{
                        ['bg-gray-300 text-gray-900 shadow-md']: form.selected && form.selected.id == item.id,
                        ['bg-gray-100 hover:bg-gray-200 text-gray-900']: !form.selected || form.selected.id != item.id,
                    }"
                    @click="(ev) => { if(form.selected != item) form.selected = item; else form.selected = null }"
                >
                    <div class="text-xs text-left">
                        <div class="px-0 py-1">{{ item.name }}: {{getDiscount(item)}}</div>
                        <h2 class="px-0 py-1">
                            <span class="font-bold">{{__('Type of discount', null, $page.props.profile_locale)}}: </span>{{ __(`message.${item.discount_type}`) }}
                        </h2>
                    </div>
                    <div class="text-xs text-left divide-y divide-gray-300 flex-1">
                        <ul class="divide-y divide-gray-300">
                            <li
                                v-for="product in item.products"
                                :key="product.id"
                                class="flex py-1"
                            >
                                <div
                                    class="uppercase rounded-md px-1 text-red-700"
                                    :class="{
                                        // ['bg-red-700 text-gray-200'] : form.selected && form.selected.id == item.id,
                                        // ['text-red-700'] : !form.selected || form.selected.id != item.id,
                                    }"
                                >
                                {{ product.locale }}</div>
                                <div class="truncate">{{ product.name }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </template>
            <div v-if="!coupons.length">
                <span>{{__("For this country you don't have any coupons", null, $page.props.profile_locale)}}</span>
            </div>
            <div class="flex justify-end space-x-3">
                <Button
                    @click="discountSave()"
                    :disabled="!(coupons.length && (form.selected && form.selected.id != form.user.coupon_id))"
                >{{__('Assign', null, $page.props.profile_locale)}}</Button>
                <Button
                    v-if="coupons.length && (form.selected && form.user.coupon_id)"
                    color="red"
                    @click="discountSave(true)"
                >{{__('Remove', null, $page.props.profile_locale)}}</Button>
            </div>
        </div>
        </CustomModal>
    </Dashboard>
</template>

<script>
import Dashboard from '@/Layouts/Dashboard';
import Heading from 'COMP/Heading';
import IconLink from 'UI/IconLink';
import CustomModal from 'UI/CustomModal';

import {
    getFullName,
    getFullAddress,
    getDate,
    getDiscount,
    getLangImage
} from 'helper';
import { ref } from '@vue/reactivity';
import Button from '@/Components/ui/Button.vue';
import { useForm, usePage } from '@inertiajs/inertia-vue3';

export default {
    components: {
        Dashboard,
        Heading,
        IconLink,
        CustomModal,
        Button,
    },


    props: ['users', 'coupons'],

    setup(props) {
        const showModal = ref({
            show: false,
            close: false,
        });

        const form = useForm({
            selected: null,
            user: null,
        });

        function openModal(user){
            showModal.value.show = true;
            form.user = user;
            form.selected = user.coupon;
        }

        function discountSave(remove = false) {
            form
            .transform((data) => ({
                ...data,
                selected: remove ? null : data.selected,
            }))
            .post(route('admin.users.discount'), {
                preserveScroll: true,
                onSuccess: (e) => { showModal.value.close = true; },
            })
        }

        return {
            getFullName,
            getFullAddress,
            getDate,
            getDiscount,
            getLangImage,

            openModal,
            discountSave,

            showModal,
            form,
        }
    }
}
</script>

<style>

</style>
